import React, { useState } from 'react';
import '../blocks/ModernBlocks.css';

const GalleryBlock = ({ data }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <div className="gallery-header">
          <h2 className="gallery-title">{data.title}</h2>
          <p className="gallery-subtitle">{data.subtitle}</p>
        </div>
        <div className="gallery-grid">
          {data.images.map((image, index) => (
            <div 
              key={index} 
              className="gallery-item"
              onClick={() => openModal(image)}
            >
              <div className="gallery-image">
                <img src={image.url} alt={image.title} />
                <div className="gallery-overlay">
                  <div className="gallery-content">
                    <h3 className="gallery-image-title">{image.title}</h3>
                    <p className="gallery-image-description">{image.description}</p>
                    <span className="gallery-view-btn">View Details</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="gallery-modal" onClick={closeModal}>
          <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="gallery-modal-close" onClick={closeModal}>×</button>
            <img src={selectedImage.url} alt={selectedImage.title} />
            <div className="gallery-modal-info">
              <h3>{selectedImage.title}</h3>
              <p>{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default GalleryBlock; 